import { FC, PropsWithChildren, useEffect } from "react";
import Footer from "components/layout/footer";
import Header from "components/layout/header";
import { RootState } from 'store/types';
import { connect } from "react-redux";
import Filters from "components/layout/filters";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { setFiltersOpen } from "store/actions/filters";
import Sidebar from "components/layout/sidebar";

interface StateProps {
  filtersOpen: boolean; 
  isAuthenticated: boolean;
}

interface DispatchProps {
  setFiltersOpen: (isOpen: boolean) => void;
}

type OwnProps = RouteComponentProps & { tabNav?: boolean };
type LayoutWithFiltersProps = StateProps & DispatchProps & OwnProps;

const toggleFiltersOpenClass = (toggle: boolean): void => {
  document.body.classList.toggle('filters-open', toggle);
};

const FullLayoutWithFilters: FC<PropsWithChildren<LayoutWithFiltersProps>> = ({ isAuthenticated, filtersOpen, setFiltersOpen, children, tabNav }: PropsWithChildren<LayoutWithFiltersProps>) => {
  useEffect(() => {
    toggleFiltersOpenClass(filtersOpen);
  }, [filtersOpen]);
  
  useEffect(() => {
    return () => {
      setFiltersOpen(false);
      toggleFiltersOpenClass(false);
    }
  }, [setFiltersOpen]);
  
  return (
    <div className={`app app-layout-full app-layout-with-filters ${isAuthenticated ? 'app-layout-authorized' : ''} ${filtersOpen ? 'filters-open' : ''}`.trim()}>
      <Sidebar />
      <Header />
      {tabNav && (
        <div className="app-tab-nav" id="app-tab-nav" />
      )}
      <div className="container-fluid app-content">
        {children}
      </div>
      <Footer />
      <Filters />
    </div>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  filtersOpen: state.filter.filters.isOpen,
  isAuthenticated: state.session.isAuthenticated,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setFiltersOpen: (isOpen: boolean) => dispatch(setFiltersOpen(isOpen))
});

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FullLayoutWithFilters));